import { render, staticRenderFns } from "./BurgerButton.vue?vue&type=template&id=7be86892&scoped=true"
import script from "./BurgerButton.vue?vue&type=script&lang=js"
export * from "./BurgerButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be86892",
  null
  
)

export default component.exports